import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import useIsParticipant from "@/features/auth/hooks/useIsParticipant";
import { generatePath } from "@/helpers/routes/routePaths";
import { isNationalPlusUpCampaign } from "@/features/campaigns/direct-mail/national-plus-up/utils/nationalPlusUpHelpers";
import type { DirectMailCampaignCardData } from "./directMailCampaignCardTypes";

const RouterLink = Link as React.ElementType;

type DirectMailCampaignJoinButtonProps = {
  campaign?: DirectMailCampaignCardData;
  participantId?: string | number;
};

export default function DirectMailCampaignJoinButton({
  campaign,
  participantId,
}: DirectMailCampaignJoinButtonProps) {
  const isPreview = !useIsParticipant();
  const { id } = campaign || {};
  const isDraft =
    campaign?.has_drafts ||
    campaign?.participant_campaign?.is_draft ||
    campaign?.is_draft;
  const search = participantId ? `?participantId=${participantId}` : "";
  const pathname = isNationalPlusUpCampaign(campaign)
    ? generatePath.joinNationalPlusUpCampaign(id)
    : `/participant/join-postcard-campaign/${id}`;
  const to = {
    pathname,
    search,
    state: { campaignId: id, from: "/dashboard" },
  };

  return (
    <Button
      variant="contained"
      color="primary"
      component={RouterLink}
      to={to}
      disableElevation
      className="fs-11"
      fullWidth
    >
      {isPreview ? "Preview" : isDraft ? "Finalize Selections" : "Join Now"}
    </Button>
  );
}
